export const video = () => {
  const videos = document.querySelectorAll<HTMLVideoElement>("[js-video]");
  const videoControls = document.querySelectorAll("[js-video-control]");

  if (!videos || !videoControls) {
    return;
  }

  videos.forEach((video, index) => {
    const videoControl = videoControls[index];
    /* On click of video control button, toggle play / pause of video */
    videoControl.addEventListener("click", () => {
      if (video.paused) {
        video.play();
        videoControl.setAttribute("aria-label", "Pause background video");
      } else {
        video.pause();
        videoControl.setAttribute("aria-label", "Play background video");
      }

      /* Hide / show play / pause icon */
      videoControl
        .querySelectorAll("svg")
        .forEach((icon) => icon.classList.toggle("display--n"));
    });
  });
};
